import { NestAPI } from '@marketing-milk/frontend'
import { AdCreativeComment } from '@marketing-milk/interfaces'
import { useQuery } from 'react-query'

interface UseGetCreativeMessagesProps {
  businessID: string
  adCreativeID: number
  enabled?: boolean
}

const fetchCreativeMessages = async (
  businessID: string,
  adCreativeID: number
): Promise<AdCreativeComment[]> => {
  const response = await NestAPI.get<AdCreativeComment[]>(
    `businesses/${businessID}/ad-creatives/${adCreativeID}/comments`
  )
  return response.data
}

export const useGetCreativeMessages = ({
  businessID,
  adCreativeID,
  enabled = true,
}: UseGetCreativeMessagesProps) => {
  const {
    data: comments = [],
    isLoading,
    error,
    refetch,
  } = useQuery<AdCreativeComment[], Error>(
    ['creativeMessages', businessID, adCreativeID],
    () => fetchCreativeMessages(businessID, adCreativeID),
    {
      enabled,
      refetchInterval: 60000, // Poll every 60 seconds (1 minute)
      refetchOnWindowFocus: true,
      staleTime: 30000, // Consider data stale after 30 seconds
    }
  )

  return { comments, isLoading, error, refetch }
}
